import * as React from 'react'
import { observer } from 'mobx-react'
import BusinessInfoViewModel from './../BusinessInfoViewModel'

import { Section, SectionItem } from '../../components/Section'
import { PhysicalAddressSectionItems } from 'jobs/info-gathering/components/PhysicalAddress'
import SectionEmptyState from 'jobs/info-gathering/components/SectionEmptyState'
import EditBusinessProfileDialog from 'jobs/views/JobRoot/Job/CapturedInformationCard/EditBusinessProfileDialog'
import EditBusinessProfileDialogViewModel from 'jobs/views/JobRoot/Job/CapturedInformationCard/EditBusinessProfileDialog/EditBusinessProfileDialogViewModel'
import Button from 'components/Button'

interface Props {
  vm: BusinessInfoViewModel
  editVM?: EditBusinessProfileDialogViewModel
  canEdit?: boolean
}

export default observer(function BusinessInfo({ vm, editVM, canEdit }: Props) {
  const profile = vm.profile
  const editable = Boolean(canEdit && editVM)

  if (!profile && !editable) {
    return <></>
  }

  return (
    <>
      {!profile && editVM && (
        <SectionEmptyState
          title="No business info yet"
          actionLabel="Fill in business info"
          onAction={() => editVM.show()}
          data-test="business-profile-empty-state-action"
        />
      )}
      {profile && (
        <>
          <Section
            title="Business Information"
            loading={vm.activate.pending}
            actions={
              editable && editVM ? (
                <Button
                  type="text"
                  onClick={() => editVM.show()}
                  data-test="update-business-information-button"
                >
                  Edit
                </Button>
              ) : undefined
            }
          >
            <SectionItem
              label="Business name"
              value={profile?.businessInfo?.businessName}
            />

            <SectionItem
              label="Date of incorporation"
              value={profile?.businessInfo?.dateOfIncorporation}
            />

            <SectionItem
              label="Employer identification number (EIN)"
              value={profile?.businessInfo?.employerIdentificationNumber}
              maskedValue={
                profile?.businessInfo?.employerIdentificationNumberDisplay
              }
              isSensitive
            />
          </Section>

          <Section title="Contact Information" bordered>
            <PhysicalAddressSectionItems vm={profile?.contactInfo} />
          </Section>
        </>
      )}
      {editVM && <EditBusinessProfileDialog vm={editVM} />}
    </>
  )
})
